import { useSelector } from 'react-redux';
import {
  selectIsMoneySourceWidgetVisibleInPromotionWrapper,
  selectIsPromotionToggleVisible,
} from '../../../../../selectors/elementsVisibility';
import {
  selectDisablePromotionSection,
  selectIsDisabledPromotion,
  selectIsPromotionPackageSelected,
  selectIsWithoutServices,
} from '../../../../../selectors/publishTerms';

export const usePromotionLayout = () => {
  const showMoneySourceWidget = useSelector(selectIsMoneySourceWidgetVisibleInPromotionWrapper);
  const isWithoutServices = useSelector(selectIsWithoutServices);
  const isPromotionDisabled = useSelector(selectIsDisabledPromotion);
  const isPromotionPackageSelected = useSelector(selectIsPromotionPackageSelected);
  const blurDisabledServices = useSelector(selectDisablePromotionSection);
  const isPromotionToggleVisible = useSelector(selectIsPromotionToggleVisible);

  const showServicesToggle = !isPromotionPackageSelected && isPromotionToggleVisible;
  const showNoServicesScreen =
    !isPromotionPackageSelected && (isWithoutServices || isPromotionDisabled) && !blurDisabledServices;

  return {
    showServicesToggle,
    showMoneySourceWidget,
    showNoServicesScreen,
  };
};
